import React from 'react'

const RsErrorGroup = React.lazy(() => import('pages/RsErrorGroup/RsErrorGroup'));
const RsErrorGroupAdd = React.lazy(() => import('pages/RsErrorGroup/RsErrorGroupAdd'));
const RsErrorGroupEdit = React.lazy(() => import('pages/RsErrorGroup/RsErrorGroupEdit'));
const RsErrorGroupDetail = React.lazy(() => import('pages/RsErrorGroup/RsErrorGroupDetail'));

const RsErrorGroupRoutes = [
    {
        path: '/rs-error-group',
        exact: true,
        name: 'Danh sách nhóm lỗi máy',
        function: 'RS_ERRORGROUP_VIEW',
        component: RsErrorGroup,
    },
    {
        path: '/rs-error-group/add',
        exact: true,
        name: 'Thêm mới nhóm lỗi máy',
        function: 'RS_ERRORGROUP_ADD',
        component: RsErrorGroupAdd,
    },
    {
        path: '/rs-error-group/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'RS_ERRORGROUP_VIEW',
        component: RsErrorGroupDetail,
    },
    {
        path: '/rs-error-group/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_ERRORGROUP_EDIT',
        component: RsErrorGroupEdit,
    },
]

export default RsErrorGroupRoutes
